import React, { Component } from 'react';
import JobFullDetails from './job-full-details.jsx';
import PortalJobScheduler from '../job-scheduling/portal-job-scheduler.jsx';
import { Animate } from 'react-simple-animate';
import moment from 'moment';
import RegNoteBox from './reg-note-box.jsx';
import RegCNoteBox from './reg-c-box.jsx';
export default class Job extends Component {
  constructor(props) {
    super(props);
    let that = this;
    this.state = {
      showFullJobDetails: false,
      data: props.data || null,
      original: {
        distance_in_miles: props.data.distance_in_miles,
        estimated_duration: props.data.estimated_duration,
        job_price: props.data.job_price,
        driver_price: props.data.driver_price,
        invoice_number: props.data.invoice_number,
      },
      showJobScheduler: false,
      isLoading: !props.data,
      play: false,
      changeInvoiceNumberApiUrl: "/api/v1/portal/jobs/change-invoice-number/",
      driverScreen:props.driverScreen || false,
      jobIndex:props.jobIndex || 0,
      jobIds:props.jobIds || [],
      groupWorkScreen:props.groupWorkScreen || false,
      customerAllJobsPage:props.customerAllJobsPage || false,
      showJobNoteBox: false,
      currentScreen : null,
      quotedStatus: null,
      isSubmitting: false,
      hasResponded: false,
      currentPage: window.location.pathname,
    };
    Echo.channel(
      'jobs-table-'+this.state.data.id
    ).listen(
      'JobsTableChanged',
      (e) => {
        that.setState({
          isLoading: true
        });
        that.getJobData();
      }
    );
    this.handleJobDistanceChange = this.
    handleJobDistanceChange.bind(this);
    this.handleJobEstimatedDurationChange = this.
    handleJobEstimatedDurationChange.bind(this);
    this.handleJobPriceChange = this.
    handleJobPriceChange.bind(this);
    this.handleDeliveryCostChange = this.
    handleDeliveryCostChange.bind(this);
    this.handleCollectionCostChange = this.
    handleCollectionCostChange.bind(this);
    this.handleDriverPriceChange = this.
    handleDriverPriceChange.bind(this);
    this.handleJobInvoiceNumberChange = this.
    handleJobInvoiceNumberChange.bind(this);
    this.changeJobPrice = this.
    changeJobPrice.bind(this);
    this.changeDeliveryCost = this.
    changeDeliveryCost.bind(this);
    this.changeCollectionCost = this.
    changeCollectionCost.bind(this);
    this.handleSchedulerHide = this.
    handleSchedulerHide.bind(this);
    this.handleMoveButtonClick = this.handleMoveButtonClick.bind(this);
    this.handleJobOrder = this.handleJobOrder.bind(this);
    this.handleArrayMove = this.handleArrayMove.bind(this);
    this.handleJobDataIndexes = this.handleJobDataIndexes.bind(this);
    this.handleHideRegNoteBox = this.handleHideRegNoteBox.bind(this);
    this.handleRegistrationNote = this.handleRegistrationNote.bind(this);
    this.getScreenName = this.getScreenName.bind(this);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    this.applyColumnToggleSettings();
  }
  handleSchedulerHide(){
    this.setState({showJobScheduler: false});
  }
  componentWillMount(){
    this.getScreenName();
  }
  componentDidMount() {
    this.calculateGrossProfitPercentage();
    this.applyColumnToggleSettings();
    this.setState({
      play: true
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      original: {
        distance_in_miles: nextProps.data.distance_in_miles,
        estimated_duration: nextProps.data.estimated_duration,
        job_price: nextProps.data.job_price,
        driver_price: nextProps.data.driver_price,
        invoice_number: nextProps.data.invoice_number,
      },
      jobIds:nextProps.jobIds,
      customerAllJobsPage:nextProps.customerAllJobsPage
    });
  }
  applyColumnToggleSettings() {
    let toggleSettings = window.jobs_table_column_toggle_settings;
    if (toggleSettings && this.state.data) {
      if (toggleSettings.job_number) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-number'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-number'
        ).style.display = "none";
      }
        if (toggleSettings.job_type) {
          document.querySelector("#jobs-table-row-"+
            this.state.data.id+' .column-type-job-type'
          ).style.display = "flex";
        }
        else {
          document.querySelector("#jobs-table-row-"+
            this.state.data.id+' .column-type-job-type'
          ).style.display = "none";
        }
      if (toggleSettings.company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-company'
        ).style.display = "none";
      }
      if (toggleSettings.original_company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-original-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-original-company'
        ).style.display = "none";
      }
      if (toggleSettings.subcontracted_by_company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-by-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-by-company'
        ).style.display = "none";
      }
      if (toggleSettings.subcontracted_to_company) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-to-company'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-subcontracted-to-company'
        ).style.display = "none";
      }
      if (toggleSettings.required_pickup) {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-required-pickup'
        ).style.display = "flex";
      }
      else {
        document.querySelector(
          "#jobs-table-row-"+this.state.data.id+
          ' .column-type-required-pickup'
        ).style.display = "none";
      }
      if (toggleSettings.required_dropoff) {
        document.querySelector("#jobs-table-row-" +
          ""+this.state.data.id+' .column-type-required-dropoff'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-required-dropoff'
        ).style.display = "none";
      }
      if (toggleSettings.scheduled_pickup) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-pickup'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-pickup'
        ).style.display = "none";
      }
      if (toggleSettings.scheduled_dropoff) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-dropoff'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-scheduled-dropoff'
        ).style.display = "none";
      }
      if (toggleSettings.reg) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-reg'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-reg'
        ).style.display = "none";
      }

      if (toggleSettings.reg_note) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-reg_note'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-reg_note'
        ).style.display = "none";
      }

      if(toggleSettings.three_little_words) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-three-little-words'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-three-little-words'
        ).style.display = "none";
      }

      const { currentPage, data } = this.state;
      if (
        ['/jobs/unplanned', '/jobs/delivered', '/drivers/schedules', '/jobs/all', '/quotes', '/rejected-quotes'].includes(currentPage)
      ) {
        const cNoteElement = document.querySelector(
          `#jobs-table-row-${data.id} .column-type-c_note`
        );

        if (cNoteElement) {
          cNoteElement.style.display = toggleSettings.c_note ? "flex" : "none";
        }
      }


      if (toggleSettings.vehicle_on_site) {
        document.querySelector('#jobs-table-row-'+
        this.state.data.id+' .column-type-vehicle-on-site'
        ).style.display = "flex";
      }
      else {
        document.querySelector('#jobs-table-row-'+
          this.state.data.id+' .column-type-vehicle-on-site'
        ).style.display = "none";
      }

      if (toggleSettings.customer) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-customer'
        ).style.display = "none";
      }
      if (toggleSettings.pickup_from) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-from'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-from'
        ).style.display = "none";
      }
      if (toggleSettings.pickup_town_city) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-town-city'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-town-city'
        ).style.display = "none";
      }
      if (toggleSettings.pickup_postcode) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-postcode'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-pickup-postcode'
        ).style.display = "none";
      }
      if (toggleSettings.dropoff_to) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-to'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-to'
        ).style.display = "none";
      }

      if (toggleSettings.dropoff_town_city) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-town-city'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-town-city'
        ).style.display = "none";
      }

      if (toggleSettings.dropoff_postcode) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-postcode'
        ).style.display = "flex";
      
      } else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-dropoff-postcode'
        ).style.display = "none";
      }
      if (toggleSettings.driver) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver'
        ).style.display = "none";
      }
      if (toggleSettings.status) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-status'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-status'
        ).style.display = "none";
      }
      if (toggleSettings.distance_in_miles) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-distance-in-miles'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-distance-in-miles'
        ).style.display = "none";
      }
      if (toggleSettings.estimated_duration) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-estimated-duration'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-estimated-duration'
        ).style.display = "none";
      }
      if (toggleSettings.job_price) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-price'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-job-price'
        ).style.display = "none";
      }
      if (toggleSettings.driver_price) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-price'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-price'
        ).style.display = "none";
      }
      if (toggleSettings.expenses_price) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-expenses-price'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-expenses-price'
        ).style.display = "none";
      }
      if (toggleSettings.gross_profit_percentage) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-gross-profit-percentage'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-gross-profit-percentage'
        ).style.display = "none";
      }
      if (toggleSettings.invoice_month) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-month'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-month'
        ).style.display = "none";
      }
      if (toggleSettings.invoice_number) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-number'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-invoice-number'
        ).style.display = "none";
      }
      if (toggleSettings.driver_delivered_date) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-delivered-date'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-driver-delivered-date'
        ).style.display = "none";
      }
      if (toggleSettings.confirmed_on_site) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-confirmed_on_site'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-confirmed_on_site'
        ).style.display = "none";
      }
      if (toggleSettings.hire_only_weeks) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-hire-only-weeks'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-hire-only-weeks'
        ).style.display = "none";
      }
      if (toggleSettings.hire_only_week_cost) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-hire-only-week-cost'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-hire-only-week-cost'
        ).style.display = "none";
      }
      if (toggleSettings.delivery_cost) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-delivery-cost'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-delivery-cost'
        ).style.display = "none";
      }
      if (toggleSettings.collection_cost) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-collection-cost'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-collection-cost'
        ).style.display = "none";
      }
      const el = document.querySelector("#jobs-table-row-" + this.state.data.id + " .column-type-job-quoted");
      if (el) {
        el.style.display = toggleSettings.job_quoted ? "flex" : "flex";
      }
      if (toggleSettings.full_details) {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-full-details'
        ).style.display = "flex";
      }
      else {
        document.querySelector("#jobs-table-row-"+
          this.state.data.id+' .column-type-full-details'
        ).style.display = "none";
      }
    }
  }
  getJobData() {
    if (this.state && this.state.data && this.state.data.id) {
      return fetch('/api/v1/portal/jobs/view/' +
        this.state.data.id, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          this.setState({
            data: response.data[0],
            isLoading: false
          })
        });
      });
    }
  }

  sendQuoteResponse = async (action) => {
    const { data } = this.state;

    this.setState({ isSubmitting: true });

    try {
      await fetch(`api/v1/portal/jobs/${data.id}/quote-action`, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: action, // 'accepted' or 'rejected'
          via: 'on_phone_call', // or 'email_fallback_link' dynamically
          remark: '', // you could add a text input if needed
        })
      });

      this.setState({ quotedStatus: action === 'approved' ? 'accepted' : 'rejected', isSubmitting: false, hasResponded: false });

      if (action === 'approved') {
        alert('Quote has been accepted successfully.');
      } else {
        alert('Quote has been rejected.');
      }
      window.location.reload();
    } catch (error) {
      console.error('Failed to submit quote response', error);
      alert('Error submitting your response.');
      this.setState({ isSubmitting: false });
    }
  };

  getNearestFutureQuoteDate() {
    let today = new Date();
    let dates = this.state.data.quote_at ? [new Date(this.state.data.quote_at)] : [];
    if (dates.length > 0) {
      dates.sort((a, b) => a - b);
      let nearestFutureDate = null;
      for (let date of dates) {
        if (date > today) {
          nearestFutureDate = date;
          break;
        }
      }
      return nearestFutureDate ? moment(nearestFutureDate).format('DD/MM/YY HH:mm:ss').toString() : "?";
    } else {
      return "?";
    }
  }

  showFullJobDetails(jobId) {
    let fullDetailsIcon = document.querySelector(
      '#fa-full-details-icon-'+jobId
    );
    fullDetailsIcon.classList.toggle('fa-level-down-alt');
    fullDetailsIcon.classList.toggle('fa-minus');
    document.querySelector(
      '.jobs-table-row-summary#jobs-table-row-'+jobId
    ).classList.toggle('bold');
    this.setState(
      {
        showFullJobDetails: !this.state.showFullJobDetails
      }
    );
  }
  changeDistanceInMiles(e) {
    let newDistanceInMiles = e.target.value;
    if (newDistanceInMiles === this.state.original.distance_in_miles) {
      return null;
    }
    let changeDistanceInMiles = confirm(
      'change Distance to '+ newDistanceInMiles + '?'
    );
    if (changeDistanceInMiles) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-distance-in-miles/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          distance_in_miles: newDistanceInMiles
        },
        cache: false,
        method: 'post',
      })
      .done(function(data) {
      //  alert('cancelled');
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=distance_in_miles]"
      ).val(
        this.state.data.distance_in_miles
      );
    }
  }
  changeEstimatedDuration(e) {
    let newEstimatedDuration = e.target.value;
    if (newEstimatedDuration === this.state.original.estimated_duration) {
      return null;
    }
    let changeEstimatedDuration = confirm(
      'change Duration to '+ newEstimatedDuration + '?'
    );
    if (changeEstimatedDuration) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-estimated-duration/"+
          this.state.data.id,
        data: {
          api_token: window.api_token,
          estimated_duration: newEstimatedDuration
        },
        cache: false,
        method: 'post',
      })
      .done(function(data) {
        // ?
      });
    }
    else {
      $(
        "#jobs-table-row-"+this.state.data.id+" input[name=estimated_duration]"
      ).val(
        this.state.data.estimated_duration
      );
    }
  }
  changeJobPrice(e) {
    let newJobPrice = this.state.data.job_price;
    if (newJobPrice === this.state.original.job_price) {
      return null;
    }
    let changeJobPrice = confirm('change JobPrice to £'+ newJobPrice + '?');
    let that = this;
    if (changeJobPrice) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-job-price/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          job_price: newJobPrice
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        that.calculateGrossProfitPercentage();
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=job_price]").
      val(e.target.value);
    }
  }

  changeDeliveryCost(e) {
    let newDeliveryCost = this.state.data.delivery_cost;
    if (newDeliveryCost === this.state.original.delivery_cost) {
      return null;
    }
    let changeDeliveryCost = confirm('change delivery cost to £'+ newDeliveryCost + '?');
    let that = this;
    if (changeDeliveryCost) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-delivery-cost/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          delivery_cost: newDeliveryCost
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        that.calculateGrossProfitPercentage();
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=delivery_cost]").
      val(e.target.value);
    }
  }

  changeCollectionCost(e) {
    let newCollectionCost = this.state.data.collection_cost;
    if (newCollectionCost === this.state.original.collection_cost) {
      return null;
    }
    let changeCollectionCost = confirm('change JobPrice to £'+ newCollectionCost + '?');
    let that = this;
    if (changeCollectionCost) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-collection-cost/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          collection_cost: newCollectionCost
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        that.calculateGrossProfitPercentage();
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=collection_cost]").
      val(e.target.value);
    }
  }
  changeDriverPrice(e) {
    let newDriverPrice = e.target.value;
    if (newDriverPrice === this.state.original.driver_price) {
      return null;
    }
    let changeDriverPrice = confirm(
      'change DriverPrice to £'+ newDriverPrice + '?'
    );
    let that = this;
    if (changeDriverPrice) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-driver-price/"+this.state.data.id,
        data: {
          api_token: window.api_token,
          driver_price: newDriverPrice
        },
        cache: false,
        method: 'post',

      })
      .done(function() {
        that.calculateGrossProfitPercentage();
      });
    }
    else {
      $("#jobs-table-row-"+this.state.data.id+" input[name=driver_price]").val(
        e.target.value
      );
    }
  }
  changeInvoiceNumber(e) {
    let newInvoiceNumber = e.target.value;
    if (newInvoiceNumber === this.state.original.invoice_number) {
      return null;
    }
    let changeInvoiceNumber = confirm(
      'change InvoiceNumber to ' + newInvoiceNumber + '?'
    );
    if (changeInvoiceNumber) {
      let jobId = this.state.data.id;
      return fetch(
        this.state.changeInvoiceNumberApiUrl + this.state.data.id,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify(
            {
              invoice_number: document.getElementById(
                "job-" + jobId + "-invoice-number"
              ).value
            }
          )
        }
      ).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
          //
        });
      });
    }
    else {
      $(
        "#jobs-table-row-" +
        this.state.data.id +
        " input[name=invoice_number]"
      ).val(
        e.target.value
      );
    }
  }
  handleQuickPlanButtonClick() {
    this.setState({showJobScheduler: !this.state.showJobScheduler});
  }
  handleJobDistanceChange(e) {
    let newJobDistance = e.target.value;
    let data = {...this.state.data}
    data.distance_in_miles = newJobDistance;
    this.setState({data});
  }
  handleJobEstimatedDurationChange(e) {
    let newJobEstimatedDuration = e.target.value;
    let data = {...this.state.data}
    data.estimated_duration = newJobEstimatedDuration;
    this.setState({data});
  }
  handleJobPriceChange(e) {
    console.log('handle Job Price In Pence Change');
    let pence = e.target.value;
    let newJobPrice = pence;
    let data = {...this.state.data}

    data.job_price = newJobPrice;
    this.setState({data});
  }
  handleDeliveryCostChange(e) {
    console.log('handle Delivery Cost In Pence Change');
    let pence = e.target.value;
    let newDeliveryCost = pence;
    let data = {...this.state.data}

    data.delivery_cost = newDeliveryCost;
    this.setState({data});
  }

  handleCollectionCostChange(e) {
    console.log('handle Collection Cost In Pence Change');
    let pence = e.target.value;
    let newCollectionCost = pence;
    let data = {...this.state.data}

    data.collection_cost = newCollectionCost;
    this.setState({data});
  }
  handleDriverPriceChange(e) {
    console.log('handle Driver Price In Pence Change');
    let newDriverPrice = e.target.value;
    let data = {...this.state.data};
    console.log(e.target.value);
    data.driver_price = newDriverPrice;
    this.setState({data});
  }
  handleJobInvoiceNumberChange(e) {
    let newJobInvoiceNumber = e.target.value;
    let data = {...this.state.data};
    data.invoice_number = newJobInvoiceNumber;
    this.setState({data});
  }
  handleMoveButtonClick(e,jobId,index){
    this.props.handleLoading(true);
    let row = document.querySelector('.jobs-table-row-'+jobId );
    $('#jobs-table-row-'+jobId).addClass('processing');
    let oldIndex = this.state.jobIds.indexOf(jobId);
    let currentIndex = index;
    let updatedJobIds = [];
    if ($(e.target).hasClass('fa fa-arrow-up move-up')){
        var $current = $(e.target).closest('.movejobs');
        var $previous = $current.prev('.movejobs');
        if($previous.length !== 0){
          currentIndex--;
          $current.insertBefore($previous);
            $('#jobs-table-row-'+jobId).removeClass('processing');
        }
        row.setAttribute('data-index',currentIndex);
        updatedJobIds = this.handleArrayMove(this.state.jobIds, oldIndex, currentIndex);
        
        this.handleJobOrder(currentIndex,updatedJobIds);
        return false;
    }
    else{
        var $current = $(e.target).closest('.movejobs')
        var $next = $current.next('.movejobs');
        if($next.length !== 0){
            currentIndex++;
            $current.insertAfter($next);
            $('#jobs-table-row-'+jobId).removeClass('processing');
        }
        row.setAttribute('data-index',currentIndex);
        updatedJobIds = this.handleArrayMove(this.state.jobIds, oldIndex, currentIndex);
        this.handleJobOrder(currentIndex,updatedJobIds);
        return false;
    }
    
  }
  handleJobOrder(order,updatedJobIds){
      let url = "/api/v1/portal/jobs/change-job-order/"+this.state.data.id+"/"+this.state.data.driver_id;
      return fetch(
        url,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify(
            {
              order: order,
              jobs:updatedJobIds
            }
          )
        }
      ).then((responseText) => {
        let response = responseText.json();
        response.then((response) => {
           this.props.handler(response.data);
           this.props.handleLoading(false);
           $('#jobs-table-row-'+this.state.data.id).removeClass('processing');
        });
      });
  }
  handleArrayMove(arr, old_index, new_index){
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; 
  }
  handleJobDataIndexes(updatedJobIds){
      updatedJobIds.map((id,index)=>{
          $('.jobs-table-row-'+id).attr('data-index',index);
      });
  }
  calculateGrossProfitPercentage() {
    let jobTotalPrice = parseFloat(this.state.data.job_price);
    let jobTotalCosts = parseFloat(this.state.data.expenses_price) +
                        parseFloat(this.state.data.driver_price);
    let grossProfit = jobTotalPrice - jobTotalCosts;
    let grossProfitOverTotal = grossProfit / jobTotalPrice;
    let grossProfitPercentage = grossProfitOverTotal * 100;
    this.setState({
      grossProfitPercentage: (Math.round(grossProfitPercentage))
    });
  }
  enterPressed(event) {
    let code = event.keyCode || event.which;
    if (code === 13) { // [ Enter ]
      $(event.target).trigger('blur');
    }
  }
  handleRegButtonClick(){
    this.setState({showJobNoteBox: !this.state.showJobNoteBox});
  }
  handleCButtonClick(){
    this.setState({showJobCNoteBox: !this.state.showJobCNoteBox});
    this.setState({showJobCDateBox: !this.state.showJobCDateBox});
  }
  handleHideRegNoteBox(){
    this.setState({showJobNoteBox: false});
  }
  handleHideCNoteBox(){
    this.setState({showJobCNoteBox: false});
  }

  handlehideCDateBox(){
    this.setState({showJobCDateBox: false});
  }

  handleRegistrationNote(reg_note){
    let registration_note = reg_note;
    let str = '';
    if(registration_note!=null) 
    {
      if(registration_note.length > 0)
      {
        str = registration_note.substring(0,10);
      }
    }
    return str;
  }
  handleCNote(c_note){
    let c_note_data = c_note;
    let str = '';
    if(c_note_data!=null) 
    {
      if(c_note_data.length > 0)
      {
        str = c_note_data.substring(0,10);
      }
    }
    return str;
  }
  getScreenName(){
    this.setState({currentScreen : window.location.href.substring(window.location.href.lastIndexOf('/') + 1)});
  }
  renderRequireService(){
    let reqServiceDateTime = '';
    if((this.state.data.dropoff_day != '') && (this.state.data.dropoff_day != '?')){
      reqServiceDateTime = this.state.data.dropoff_day;
    }
    if((this.state.data.dropoff_month != '') && (this.state.data.dropoff_month != '?')){
      reqServiceDateTime += '/'+this.state.data.dropoff_month;
    }
    if((this.state.data.dropoff_year != '') && (this.state.data.dropoff_year != '?')){
      reqServiceDateTime += '/'+this.state.data.dropoff_year;
    }
    if((this.state.data.dropoff_time != '0') && (this.state.data.dropoff_time != '0000-00-00 00:00:00') && (this.state.data.dropoff_time != '?')){
      reqServiceDateTime += ' '+this.state.data.dropoff_time.toUpperCase();
    }
    if(reqServiceDateTime!='')
    {
      return(
        <span className="alert alert-danger not-planned-quick-plan-button"
          onClick={(e) => this.handleQuickPlanButtonClick(e)}
        >
          {reqServiceDateTime}
        </span>
      )
    }
  }
  render() {
    let unit_data = this.state.data.unit && this.state.data.unit.units_data ? JSON.parse(this.state.data.unit.units_data): [];

    if (!this.state.data) {
      return false;
    }
    let customerAllJobsPage = this.state.customerAllJobsPage;
    let hasSplitParent = (
          this.state.data.split_parent_id > 0 &&
          this.state.data.is_split_job
        ),
        isSplitJob = this.state.data.is_split_job,
        hasSplitJobs = this.state.data.has_split_jobs,
        isSplitJobPartA = this.state.data.split_sequence === 1,
        isSplitJobPartB = this.state.data.split_sequence === 2,
        SplitJobColumnLabel = <span className="text-decorate-split-job">
                                split job
                              </span>;
        let assignedToDriverAt = this.state.data.assigned_to_driver_at,
            diffInMinute = 0;
        if(assignedToDriverAt != null){
            let assignedAt = moment(assignedToDriverAt);
            let currentTime = moment(new Date());
            diffInMinute =  currentTime.diff(assignedAt, 'minutes');
        }
        let requiredPickupDate = this.state.data.pickup_year+'-'+this.state.data.pickup_month+'-'+this.state.data.pickup_day;
        let requiredDropoffDate = this.state.data.dropoff_year+'-'+this.state.data.dropoff_month+'-'+this.state.data.dropoff_day;
        let JobIsDue48Hours = false;
        let turnsJobToRedP = false;
        let turnsJobToRedD = false;
        if(requiredPickupDate != "" || requiredPickupDate != null){
          let today = moment(),now = moment();
           /* check if job is not allocated to driver and due withing 2 days turns it into blue */
          JobIsDue48Hours = moment(requiredPickupDate).isBetween((today.format('Y-M-D')), (today.add({hours:31,minutes:30}).format('Y-M-D')), null, '[]');
          /* check if job date passed away than turns it into red */
          turnsJobToRedP = moment(requiredPickupDate).isBefore(now.format('Y-M-D'));
        }
        if(requiredDropoffDate != "" || requiredDropoffDate != null){
          let now = moment();
          turnsJobToRedD = moment(requiredDropoffDate).isBefore(now.format('Y-M-D'));
        }

    return (
        <div className={"movejobs jobs-table-row-"+this.state.data.id} data-index={this.state.jobIndex}>      
        <Animate play={this.state.play} start={{opacity: 0}} end={{opacity: 1}}>
        <div className="jobs-table-row-container">
          <div
            className={
              "jobs-table-row jobs-table-row-summary row-status-bg-"+
              this.state.data.status+" "+
              ((this.state.data.driver_id != null) ?
                ' row-status-bg-sent-to-driver ' : '')+
              ((this.state.data.driver_id != null && this.state.data.status == 'inactive' && diffInMinute >= 30 ) ?
                ' row-status-bg-sent-to-driver-but-not-accepted ' : '')+
                ((this.state.data.checked === 1) ?
                  ' row-status-bg-green-important ' : '')+
              ((this.state.data.needs_planning_asap === 1) ?
                ' row-status-bg-cyan-important ' : '')+
              ((this.state.data.does_not_require_planning_yet === 1) ?
                ' row-status-bg-grey-important ' : '')+
              ((this.state.data.prechecked === 1) ?
                ' row-status-bg-prechecked ' : '')+
              ((this.state.data.has_a_major_issue === 1) ?
                ' row-status-bg-has-a-major-issue' : '')+
              ((this.state.data.has_an_issue === 1) ?
                  ' has-an-issue' : '')+
              ((this.state.data.checked === 1 && this.state.data.unit_hired_term == 'short' && this.state.data.status == 'inactive') ?
                  ' job-marked-unplanned-togobacktodriver ' : '')+    
              ((JobIsDue48Hours && this.state.groupWorkScreen && this.state.data.driver_id == null) ? ' late-48-hours-due-job-'+JobIsDue48Hours : '')+
              (( (turnsJobToRedP || turnsJobToRedD) && this.state.groupWorkScreen && this.state.data.driver_id == null) ? ' past-job-not-collected' : '')+
              ( (this.state.data.parent_copied_jobid) ? ' has-parent-copied-jobid' : '' )
            }
            id={
              "jobs-table-row-"+
              this.state.data.id
            }
          >
           { this.state.driverScreen ?
            <div className="cell column-type-order">
                <button className='move' title='Move Up' onClick={(e) => this.handleMoveButtonClick(e,this.state.data.id,this.state.jobIndex)}>
                    <i className="fa fa-arrow-up move-up"></i>
                </button>
                <button className='move' title='Move Down' onClick={(e) => this.handleMoveButtonClick(e,this.state.data.id,this.state.jobIndex)}>
                    <i className="fa fa-arrow-down move-down"></i>
                </button>
            </div>:''
            }
            <div className="cell column-type-job-number pos-rel">
              <a href={"/jobs/view/"+this.state.data.id}>
                {
                  this.state.data.id
                }
              </a>
              {
                (isSplitJob) ?
                  <i
                    className="fa fa-strikethrough split-job-status-is-split-job"
                    title={"job #"+this.state.data.id+
                    " is a Split Job, belongs to job#"+
                     this.state.data.split_parent_id+
                     (isSplitJobPartA ?
                       " (is SplitJob PartA)" :
                       " (is SplitJob PartB)")
                    }
                  >
                  </i>
                  : null
              }
              {
                (hasSplitJobs) ?
                  <i
                    className="fa fa-strikethrough split-job-status-has-split-jobs"
                    title="this job has been split into other jobs"
                  >&nbsp;</i>
                  : null
              }
            </div>
            <div className="cell column-type-company">
              {this.state.data.company.short_name}
            </div>
            <div className="cell column-type-original-company">
              {(this.state.data.original_company &&
                this.state.data.original_company.short_name)
                ? this.state.data.original_company.short_name : ''
              }
            </div>
            <div className="cell column-type-subcontracted-by-company">
              {(this.state.data.subcontracted_by_company &&
                this.state.data.subcontracted_by_company.short_name)
                ? this.state.data.subcontracted_by_company.short_name : ''
              }
            </div>
            <div className="cell column-type-subcontracted-to-company">
               {(this.state.data.subcontracted_to_company &&
                this.state.data.subcontracted_to_company.short_name)
                ? this.state.data.subcontracted_to_company.short_name : ''
              }
            </div>
            {this.state.currentScreen === 'unplanned' || this.state.currentScreen === 'schedules' ? (
            <div
                className={
                    "cell column-type-required-dropoff" +
                    ((isSplitJob === true) ? (
                        (isSplitJobPartB === true) ?
                        ' split-job-part-b-requested-dropoff-time ' :
                        ' split-job-part-a-requested-dropoff-time '
                    ) : '')
                }
            >
              
                {this.renderRequireService()} 
                {
                    (!hasSplitJobs && ((this.state.data.required_dropoff_date == '0000-00-00 00:00:00') || (this.state.data.required_dropoff_date == null))) ?
                    <span className="alert alert-danger not-planned-quick-plan-button"
                        onClick={(e) => this.handleQuickPlanButtonClick(e)}
                    >
                        Not Scheduled&nbsp;
                        <i className="fa fa-exclamation"></i>
                    </span>
                    : null
                }
            </div>
            ) : 
            <div
               className={
                 "cell column-type-required-dropoff"+
                 (
                   (isSplitJob === true) ? (
                    (isSplitJobPartB === true) ?
                     ' split-job-part-b-requested-dropoff-time ' :
                     ' split-job-part-a-requested-dropoff-time '
                   ):''
                 )
               }
             >
               {this.state.data.dropoff_day}/
               {this.state.data.dropoff_month}/
               {this.state.data.dropoff_year} {
                 this.state.data.dropoff_time.toUpperCase()
               }
             </div>
            }
             <div className={"cell column-type-required-pickup"+(
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' split-job-part-b-requested-pickup-time ' :
                 ' split-job-part-a-requested-pickup-time '
               ):''
             )}>
             {this.state.data.pickup_day}/
             {this.state.data.pickup_month}/
             {this.state.data.pickup_year} {
               this.state.data.pickup_time.toUpperCase()
             }
             </div>
             <div className={"cell column-type-scheduled-pickup"+
             (
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' split-job-part-b-scheduled-pickup-time ' :
                 ' split-job-part-a-scheduled-pickup-time '
               ):''
             )}>
             {
               (hasSplitJobs) ?
               SplitJobColumnLabel
               : null
             }
             {
               (!hasSplitJobs &&
                (this.state.data.scheduled_pickup_preposition !== null)) ?
               <span>
             {this.state.data.scheduled_pickup_day}/
             {this.state.data.scheduled_pickup_month}/
             {this.state.data.scheduled_pickup_year} {
               this.state.data.scheduled_pickup_time.toUpperCase()
             }</span>
             : null
           }
             {
               (!hasSplitJobs &&
                (this.state.data.scheduled_pickup_preposition === null)) ?
             <span className="alert alert-danger not-planned-quick-plan-button"
                   onClick={(e) => this.handleQuickPlanButtonClick(e)}
             >
                Not Scheduled&nbsp;
                <i className="fa fa-exclamation"></i>
             </span>
             : null
           }
             </div>
             
             <div className={"cell column-type-scheduled-dropoff"+(
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' split-job-part-b-scheduled-dropoff-time ' :
                 ' split-job-part-a-scheduled-dropoff-time '
               ):''
             )}>
             {
               (hasSplitJobs) ?
               SplitJobColumnLabel
               :
             null
             }
             {
               (!hasSplitJobs &&
                (this.state.data.scheduled_dropoff_preposition !== null)) ?
                 <span>
                   {this.state.data.scheduled_dropoff_day}/
                   {this.state.data.scheduled_dropoff_month}/
                   {this.state.data.scheduled_dropoff_year} {
                     this.state.data.scheduled_dropoff_time.toUpperCase()
                   }</span>
                 : null
             }
             {
               (!hasSplitJobs &&
                (this.state.data.scheduled_dropoff_preposition === null)) ?
               <span
                 className="alert alert-danger not-planned-quick-plan-button"
                 onClick={
                   (e) => this.handleQuickPlanButtonClick(e)
                 }
               >
                Not Scheduled&nbsp;
                <i className="fa fa-exclamation"></i>
             </span>
             : null
            }
            </div>
            <div className="cell column-type-reg">
              { (!this.state.data.has_split_jobs) ? (this.state.data.unit) ? this.state.data.unit.unit_qty : "" : (this.state.data.split_jobs_ids) ? this.state.data.split_jobs_ids.split(/,/).length : "" }
            </div>
            <div className="cell column-unit-hired-term">
              {this.state.data.unit_hired_term } &nbsp;
              {( this.state.data.parent_copied_jobid) ? 
                <a href={'/jobs/view/'+this.state.data.parent_copied_jobid} target="_blank">
                   &nbsp; #{this.state.data.parent_copied_jobid} &nbsp;
                </a> : ''
              }
            </div>
            <div className="cell column-type-of-unit">
            {(this.state.data.unit) ? ((this.state.data.unit.type_of_unit_service) ? this.state.data.unit.type_of_unit_service : "" ) : "" }
            </div>
            <div className="cell column-three-little-words">
              {this.state.data.three_words_of_dropoff_address}
            </div>
            <div className="cell column-notes">
              {
                [
                  this.state.data.notes,
                  (unit_data && unit_data.units && unit_data.units.length > 0) ?
                    unit_data.units
                      .map(u => `${u.unit_type.replace(/_/g, ' ')} (${u.unit_quantity})`)
                      .join(", ")
                    : (this.state.data.unit && this.state.data.unit.unit_type) ?
                      (this.state.data.unit.length > 1 ?
                        this.state.data.unit.map(u => u.unit_type.replace(/_/g, ' ')).join(", ")
                        : this.state.data.unit.unit_type.replace(/_/g, ' ')
                      )
                      : ""
                ].filter(Boolean).join(", ")
              }
            </div>
            <div className="cell column-type-vehicle-on-site">
              {this.state.data.vehicle_on_site}
            </div>
            <div className="cell column-type-customer">
              <a href={"/portal-admin/customers/view/"+
              this.state.data.customer.id}>
                {this.state.data.customer.name}
              </a>
            </div>
            <div
              className={
                "cell column-type-pickup-from"+
                (
                  (isSplitJob === true) ? (
                   (isSplitJobPartA === true) ?
                    ' split-job-part-a-pickup ' :
                    ' split-job-part-b-pickup '
                  ):''
                )+
                (
                  (hasSplitJobs === true) ? (
                    ' split-job-parent-pickup '
                  ):''
                )
              }
               title={
                 (
                   (isSplitJob === true) ? (
                  (isSplitJobPartA === true) ?
                   ' SplitJob PartA Pickup Locked ' :
                   ' This is SplitJob PartB Pickup. '+
                    'Should match SplitJob PartA Dropoff. '
                 ):''
               )+
               (
                 (hasSplitJobs === true) ? (
                   ' SplitJob Parent Pickup Locked '
                 ):''
               )
               }
            >
              {((this.state.data.pickup_address)&&(this.state.data.pickup_address.town_city))?this.state.data.pickup_address.town_city:""} {
                ((this.state.data.pickup_address)&&(this.state.data.pickup_address.postcode)) ?
                this.state.data.pickup_address.postcode.toUpperCase():''
              }
            </div>
            <div className="cell column-type-pickup-town-city">
              {((this.state.data.pickup_address)&&(this.state.data.pickup_address.town_city))?this.state.data.pickup_address.town_city:""}
            </div>
            <div className="cell column-type-pickup-postcode">
              {((this.state.data.pickup_address)&&(this.state.data.pickup_address.postcode))?this.state.data.pickup_address.postcode:""}
            </div>

            <div className={(this.state.data.reg_note) ? "cell column-type-reg_note user-click-event yellow-bg" : "cell column-type-reg_note user-click-event"}
              data-toggle="tooltip" data-placement="right" data-original-title={this.state.data.reg_note} onClick={
                (e) => this.handleRegButtonClick(e)
              }>
              <span> 
                {this.state.data.reg_note ? this.handleRegistrationNote(this.state.data.reg_note) : 
                (this.props.is_quote ?
                      (this.state.data.unit ?
                          (this.state.data.unit.unit_term === 'short' ?
                              (this.state.data.unit.date_of_event ? moment(this.state.data.unit.date_of_event).format('DD/MM/YYYY') : '')
                              :
                              (this.state.data.unit.required_date ? moment(this.state.data.unit.required_date).format('DD/MM/YYYY') : '')
                          )
                          : ''
                      )
                      :
                      this.handleRegistrationNote(this.state.data.reg_note)
                )}
              </span>
            </div> 

            {
              (['/jobs/unplanned', '/jobs/delivered', '/drivers/schedules', '/jobs/all', '/quotes', '/rejected-quotes'].includes(this.state.currentPage) || this.state.currentPage.startsWith('/jobs/customer/')) && (
                <div
                  className={
                    this.state.data.c_note
                      ? "cell column-type-c_note user-click-event orange-bg"
                      : "cell column-type-c_note user-click-event"
                  }
                  data-toggle="tooltip"
                  data-placement="right"
                  data-original-title={this.state.data.c_note}
                  onClick={(e) => this.handleCButtonClick(e)}
                >
                  <span>{this.handleCNote(this.state.data.c_note)}</span>
                </div>
              )
            }

            <div
              className={
                "cell column-type-dropoff-to"+
                (
                  (isSplitJob === true) ? (
                   (isSplitJobPartB === true) ?
                    ' split-job-part-b-dropoff ' :
                    ' split-job-part-a-dropoff '
                  ) : ''
                )+
                (
                  (hasSplitJobs === true) ? (
                    ' split-job-parent-dropoff '
                  ) : ''
                )}
             title={
               (
               (isSplitJob === true) ? (
                (isSplitJobPartB === true) ?
                 ' SplitJob PartB Dropoff Locked ' :
                 ' This is SplitJob PartA Dropoff. '+
                  'Should match SplitJob PartB Pickup.'
               ) : ''
             )+
             (
               (hasSplitJobs === true) ? (
                 ' SplitJob Parent Dropoff Locked. '
               ) : ''
             )
            }
            >
              {((this.state.data.dropoff_address)&&(this.state.data.dropoff_address.town_city))?this.state.data.dropoff_address.town_city:""}  {
                ((this.state.data.dropoff_address)&&(this.state.data.dropoff_address.postcode)) ?
                this.state.data.dropoff_address.postcode.toUpperCase():''
              }
            </div>
            <div className="cell column-type-dropoff-address">
              {this.state.data.dropoff_address.address_line_1}
            </div>
            <div className="cell column-type-dropoff-town-city">
              {((this.state.data.dropoff_address)&&(this.state.data.dropoff_address.town_city))?this.state.data.dropoff_address.town_city:""}
            </div>
            <div className="cell column-type-dropoff-postcode">
              {((this.state.data.dropoff_address)&&(this.state.data.dropoff_address.postcode))?this.state.data.dropoff_address.postcode:""}
            </div>
              
            <div className="cell column-type-driver">
            {
              (hasSplitJobs) ?
              SplitJobColumnLabel
              : null
            }
            {
              (this.state.data.driver !== null &&
                !hasSplitJobs) ?
                <span className="jobs-table-row-driver-name">
                  {this.state.data.driver.user.first_name+' '+
                  this.state.data.driver.user.last_name}
                </span>
               : null
            }
            {
              (this.state.data.saved_driver !== null &&
               this.state.data.driver === null &&
                !hasSplitJobs) ?
                <span
                  className="jobs-table-row-driver-name pencilled-in-driver">
                  {(this.state.data.saved_driver &&
                    this.state.data.saved_driver.user) ?
                    (this.state.data.saved_driver.user.first_name + ' ' +
                      this.state.data.saved_driver.user.last_name) : ' ERROR '
                  }
                </span>
                  : null
            }
            {
              (this.state.data.driver === null &&
               this.state.data.saved_driver === null &&
                !hasSplitJobs) ?
              <span
                className="alert alert-danger not-planned-quick-plan-button"
                onClick={(e) => this.handleQuickPlanButtonClick(e)}
              >
                 No Driver <i className="fa fa-exclamation">&nbsp;</i>
              </span>
              : null
            }
            </div>
            <div
              className={
                "cell column-type-status status-bg-"+
                this.state.data.status
              }
            >
            {
              (this.state.data.status === 'completed_awaiting_data') ?
              'completed, awaiting data' :
              this.state.data.status
            }
            </div>
            <div className="cell column-type-distance-in-miles">
              <span className="cell-label">
              <input type="text" className="jobs-table-editable"
              value={this.state.data.distance_in_miles || ''}
              onChange={this.handleJobDistanceChange}
              onBlur={(e) => this.changeDistanceInMiles(e)}
              onKeyUp={this.enterPressed.bind(this)}
              name="distance_in_miles" />
              </span>
            </div>
            <div className="cell column-type-estimated-duration">
            {
              (hasSplitJobs) ?
              SplitJobColumnLabel
              :
                <span className="cell-label">
              <input type="text" className="jobs-table-editable"
              value={this.state.data.estimated_duration || ''}
              onChange={this.handleJobEstimatedDurationChange}
              onBlur={(e) => this.changeEstimatedDuration(e)}
              onKeyUp={this.enterPressed.bind(this)}
              name="estimated_duration" />
              </span>
            }
            </div>
            <div className="cell column-type-job-price">
            <span className="cell-label pound-sign-label">
            <input type="text" className="jobs-table-editable"
            value={this.state.data.job_price || ''}
            onBlur={(e) => this.changeJobPrice(e)}
            onChange={this.handleJobPriceChange}
              onKeyUp={this.enterPressed.bind(this)}
            name="job_price" />
            </span>

            </div>
            <div className="cell column-type-driver-price">
            {
              (hasSplitJobs) ?
              SplitJobColumnLabel
              :
              <span className="cell-label pound-sign-label">
              <input type="text" className="jobs-table-editable"
              value={this.state.data.driver_price || ''}
              onBlur={(e) => this.changeDriverPrice(e)}
              onChange={this.handleDriverPriceChange}
              onKeyUp={this.enterPressed.bind(this)}
              name="driver_price" />
              </span>
            }
            </div>
            <div className="cell column-type-expenses-price">
              <span className="cell-label pound-sign-label">
                {this.state.data.expenses_price}
              </span>
            </div>
            <div className={"cell column-type-gross-profit-percentage " + (
              (this.state.grossProfitPercentage < 25) ?
              'less-than-25' :
              'more-than-25'
            )}>
              {this.state.grossProfitPercentage}%
            </div>
            <div className="cell column-type-invoice-month">
              {
                this.state.data.driver_completed_at ?
                  moment(
                    this.state.data.driver_completed_at
                  ).format(
                    'MMMM'
                  ).toString()
                  :
                  '?'
              }
            </div>
            <div className="cell column-type-invoice-number">
              <span className="cell-label">
              <input
                type="text"
                className="jobs-table-editable"
                value={this.state.data.invoice_number || ''}
                onChange={this.handleJobInvoiceNumberChange}
                onBlur={(e) => this.changeInvoiceNumber(e)}
                onKeyUp={this.enterPressed.bind(this)}
                placeholder="invoice #"
                name="invoice_number"
                id={"job-" + this.state.data.id + "-invoice-number"}
              />
              </span>
            </div>
            <div className="cell column-type-job-type">
            { this.state.data.job_type }
            </div>
            <div className="cell column-type-driver-delivered-date">
                { (this.state.data.driver_completed_at != null) ? moment(this.state.data.driver_completed_at).format('DD/MM/YY HH:mm:ss').toString() : "?"}
            </div>
            <div className={ (this.state.data.confirmed_on_site) ? 'cell column-type-confirmed_on_site':(( (this.state.data.status != 'completed') && (this.state.data.status != 'driving') && (this.state.data.status != 'split_job') ) ? 'cell column-type-confirmed_on_site red-alert' : 'cell column-type-confirmed_on_site')}>
                { (this.state.data.confirmed_on_site) ? 'Y' : ""}
            </div>
            <div className="cell column-type-hire-only-weeks">
              { this.state.data.hire_only_weeks }
            </div>
            <div className="cell column-type-hire-only-week-cost">
              { this.state.data.hire_only_week_cost }
            </div>
            <div className="cell column-type-delivery-cost">
            <span className="cell-label pound-sign-label">
            <input type="text" className="jobs-table-editable"
            value={this.state.data.delivery_cost || ''}
            onBlur={(e) => this.changeDeliveryCost(e)}
            onChange={this.handleDeliveryCostChange}
              onKeyUp={this.enterPressed.bind(this)}
            name="delivery_cost" />
            </span>
            </div>
            <div className="cell column-type-collection-cost">
            <span className="cell-label pound-sign-label">
            <input type="text" className="jobs-table-editable"
            value={this.state.data.collection_cost || ''}
            onBlur={(e) => this.changeCollectionCost(e)}
            onChange={this.handleCollectionCostChange}
              onKeyUp={this.enterPressed.bind(this)}
            name="collection_cost" />
            </span>
            </div>
              {(
                this.props.is_quote ||
                this.props.is_quote_rejected
              ) && (
                  <>
                    <div className="cell column-type-job-quoted">
                      {this.getNearestFutureQuoteDate()}
                    </div>
                    <div className="cell column-type-job-quote-button col-12 d-flex justify-content-center">
                      <button
                        className="btn btn-lg btn-sm btn-success col-6"
                        onClick={() => this.sendQuoteResponse('approved')}
                         disabled={this.state.isSubmitting || this.state.hasResponded}
                      >
                        Accept
                      </button>&nbsp;
                      {(this.props.is_quote_rejected) ? '' :
                      <button
                        className="btn btn-lg btn-sm btn-danger col-6"
                        onClick={() => this.sendQuoteResponse('rejected')}
                         disabled={this.state.isSubmitting || this.state.hasResponded}
                      >
                        Reject
                      </button>
                      }
                    </div>
                  </>
                )}
            <div className="cell column-type-full-details">
              <button
                className="btn btn-dark btn-sm"
                onClick={() => {
                  this.showFullJobDetails(this.state.data.id)}
                }
              >
              full details <i
                className="fa fa-level-down-alt"
                id={"fa-full-details-icon-"+this.state.data.id}>
              </i>
              </button>
            </div>
          </div>
          {this.state.showJobScheduler ?
            <div className="job-scheduler-container">
              <button
                className="btn btn-lg btn-danger close-job-scheduler-button"
                onClick={(e) => {
                this.setState({
                  showJobScheduler: !this.state.showJobScheduler
                });
              }}>-</button>
              <PortalJobScheduler
                jobId={this.state.data.id}
                data={this.state.data}
                isLoading={false}
                schedulerHide={this.handleSchedulerHide}
              />
            </div>
            :
            null
          }
          {
            this.state.showJobNoteBox ?
            <div className="job-scheduler-container">
              <RegNoteBox
                jobId={this.state.data.id}
                data={this.state.data}
                handleHideRegNoteBox={this.handleHideRegNoteBox}
              />
            </div>
              :
              null
          }
          {
            this.state.showJobCNoteBox && this.state.showJobCDateBox ?
            <div className="job-scheduler-container">
              <RegCNoteBox
                jobId={this.state.data.id}
                data={this.state.data}
                handleHideCNoteBox={this.handleHideCNoteBox}
                handlehideCDateBox={this.handlehideCDateBox}
              />
            </div>
              :
              null
          }
          {this.state.showFullJobDetails ?
            <JobFullDetails
              key={'job-'+this.state.data.id+'-fd'}
              data={this.state.data}
              hasSplitParent={hasSplitParent}
              isSplitJob={isSplitJob}
              hasSplitJobs={hasSplitJobs}
              isSplitJobPartA={isSplitJobPartA}
              isSplitJobPartB={isSplitJobPartB}
              customerAllJobsPage={customerAllJobsPage}
              is_quote={this.props.is_quote}
              is_quote_rejected={this.props.is_quote_rejected}
            />
            :
            null
          }
        </div>
      </Animate>
      </div>
    )
  }
}
